import { useNavigate } from "react-router-dom";
import { currentDateTime, objectToArray, payloadBuilderForObject } from "../../utils/helper";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";  
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchOfficeByCampusId, getSubsciberById } from "../../pages/actions/actions";
import { resetOfficeReqInfo } from "../../redux/officeSlice/officeSlice";
import { resetSubscriberInfo } from "../../redux/subscriberSlice/subscriberSlice";
import { ticketUpdateById } from "../../http";
import { ticketDataSuccess } from "../../redux/ticketSlice/ticketSlice";


export const    UseTicketBasicDetails = () => {
  const { getTicketData, getTicketUpdateData, subscriberData, getBenList } = UseGetStoreData();
  const navigate = useNavigate();
  const dispatch=useDispatch()
  const [showPocUpdateModal,setShowPocUpdateModal]=useState(false);
  const [isGMC, setIsGMC] = useState(false);

  useEffect(() => {
    const raisedByBenId = getTicketData?.ticketRaisedBy?.benId;
    if (!raisedByBenId || !getBenList?.length) return;
    const ben = getBenList.find((b: any) => b._id === raisedByBenId);
    setIsGMC(!!(ben?.empNo && ben?.clientId));
  }, [getTicketData?.ticketRaisedBy?.benId, getBenList]);
   const fieldsLeftRef = useRef([
    "callerID",
    "callerType",
    "sourceOfTicket",
    "companyName",
    "campusId",
    // "subscriber"
  ]);


   useEffect(()=>{
     if (getTicketData?.campusId && getTicketData?.patient&&!fieldsLeftRef.current.includes("subscriber")) {
   
         fieldsLeftRef.current = [
           ...fieldsLeftRef.current,
           "subscriber"
         ];
       

     }
    if(!getTicketData?.campusId&&!fieldsLeftRef.current.includes("subscriber")){
      fieldsLeftRef.current = [
          ...fieldsLeftRef.current,
          "subscriber"
          
        ]

    }
    if(getTicketData?.hasOwnProperty('ambulanceCount') && getTicketData?.ambulanceCount !== undefined && getTicketData?.ambulanceCount !== null && !fieldsLeftRef.current.includes("ambulanceCount")){
      fieldsLeftRef.current = [
          ...fieldsLeftRef.current,
          "ambulanceCount"  
        ]
    }
    if(getTicketData?.hasOwnProperty('beneficiaryAmbulanceCount') && getTicketData?.beneficiaryAmbulanceCount !== undefined && getTicketData?.beneficiaryAmbulanceCount !== null && !fieldsLeftRef.current.includes("beneficiaryAmbulanceCount")){
      fieldsLeftRef.current = [
          ...fieldsLeftRef.current,
          "beneficiaryAmbulanceCount"
        ]
    }
    if(getTicketData?.hasOwnProperty('doctorCount') && getTicketData?.doctorCount !== undefined && getTicketData?.doctorCount !== null && !fieldsLeftRef.current.includes("doctorCount")){
   
      fieldsLeftRef.current = [
          ...fieldsLeftRef.current, 
          "doctorCount"
        ]
    }

   },[getTicketData])


    const fieldsRight = useRef(["poc", "detectedLocation"]);
      const handleClick = () => {
          return navigate("/");
      };
      const officeResponseRef = useRef({});

useEffect(() => {
    async function init() {
   

      if (getTicketData?.campusId) {
     

        // Mutate fieldsLeftRef.current
        fieldsLeftRef.current = [
          ...fieldsLeftRef.current,
          "doctorDetails",
          "nurseDetails",
          
        ];

        fieldsRight.current = [
          ...fieldsRight.current,
           "ambulanceAvailability"
          
        ];
        const response = await fetchOfficeByCampusId({
            campusId: getTicketData.campusId,
            dispatch
          });
          officeResponseRef.current = { ...response?.data };
       

        }

    }
    
    init();
    
    return () => {
    // Cleanup on unmount
    dispatch(resetOfficeReqInfo());
    officeResponseRef.current = {};
    fieldsLeftRef.current = [];
  };

     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTicketData?.campusId]);

   useEffect(()=>{
     if(!subscriberData?.email){
        let id=getTicketData?.subscriber?.id
        if (id) {
          getSubsciberById({ id, dispatch })
        }
    
      }
      return ()=>{
        dispatch(resetSubscriberInfo())
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   },[])

   const handleTicket = async () => {
     const payload = {
       ticketStatus: "Completed",
       notes: [...(getTicketData?.notes || []), {
         date: currentDateTime(),
         message: "Emergency Resolved"
       }]
     };
     const res = await ticketUpdateById(getTicketData?._id, payload);
     dispatch(ticketDataSuccess(res?.data));
     navigate("/");
  };
    


         

       
      const getFilteredDataLeftSide = payloadBuilderForObject({
        fields: fieldsLeftRef.current,
        obj: getTicketData?{...getTicketData,...officeResponseRef.current}:{},
      });
      
       
      const transformedDataLeftSide = objectToArray({
        fields:fieldsLeftRef.current,
        obj: getFilteredDataLeftSide,
      });

      transformedDataLeftSide.push({ label: "isGMC", value: isGMC });

      const benFullName =
        getTicketUpdateData?.patient?.fullName ||
        getTicketData?.patient?.fullName ||
        getTicketData?.ticketRaisedBy?.fullName;
      if (benFullName) {
        const alreadyHasBen = transformedDataLeftSide.some(
          (item: any) => item.label === "Beneficiary Name"
        );
        if (!alreadyHasBen) {
          transformedDataLeftSide.push({ label: "Beneficiary Name", value: benFullName });
        }
      }
    
     
      const getFilteredDataRightSide = payloadBuilderForObject({
        fields: fieldsRight.current,
        obj: getTicketData?{...getTicketData,...officeResponseRef.current}:{},
      });
      
      let transformedDataRightSide = objectToArray({
        fields: fieldsRight.current,
        obj: getFilteredDataRightSide,
      });


    
    
      // console.log('isTicketDataPresent:', isTicketDataPresent);
   const handleEditPoc=()=>{
    // alert("clicked")
    setShowPocUpdateModal(!showPocUpdateModal)
   }
  //  getTicketUpdateData
  //getAlreadyFilledTicket
  const checkPatientData=getTicketData?.patient?.emergencyContacts?getTicketData?.patient?.emergencyContacts:getTicketUpdateData?.patient?.emergencyContacts
  // console.log('checkPatientData:##############', checkPatientData);
 
  if(checkPatientData){
     const getEmContact = checkPatientData.reduce((tempArr: any[], ticketData: any, index: number) => {
      tempArr.push({ label: `em${index + 1}`, value: ticketData.mobile });
      return tempArr;
  }, []);
   transformedDataRightSide=[...getEmContact,...transformedDataRightSide];
  };
  if(getTicketData?.campusId && getTicketData?.campusContacts?.length > 0){
    const getPremiseEmContact = getTicketData.campusContacts.map((contact: any, index: number) => {
      return { label: `Premise em${index + 1}`, value: contact.mobile };
    });
    transformedDataRightSide=[...getPremiseEmContact,...transformedDataRightSide];
  };

  const updatedPoc = getTicketUpdateData?.confirmedPoc;
  if (updatedPoc?.fullName || updatedPoc?.mobile) {
    transformedDataRightSide = transformedDataRightSide.map((item: any) =>
      item.label === "POC"
        ? { ...item, value: updatedPoc.mobile || item.value, name: updatedPoc.fullName || item.name }
        : item
    );
  }

  const subscriptionValue =
    subscriberData?.isSubscriptionActive === null || subscriberData?.isSubscriptionActive === undefined
      ? "N/A"
      : subscriberData.isSubscriptionActive
      ? "Active"
      : "Inactive";
  transformedDataRightSide = [...transformedDataRightSide, { label: "Subscription", value: subscriptionValue }];

  return{
    handleClick,
    transformedDataLeftSide,
    transformedDataRightSide,
    handleEditPoc,
    showPocUpdateModal,
    handleTicket,
  } 
};
